import styled from 'styled-components';
import { toRem } from '@marriott/mi-ui-library';
import { mediaQuery } from '../../../utils/styles';

export const NearByDestinationsLoaderWrapper = styled.div`
  margin-top: ${toRem(16)};
  margin-bottom: ${toRem(16)};
  .near-by-destination-header {
    width: ${toRem(300)};
    height: ${toRem(45)};
    margin-bottom: ${toRem(24)};
    border-radius: ${toRem(8)};
    @media ${mediaQuery.mobileOnly} {
      width: 60%;
      height: ${toRem(33)};
    }
  }
  .near-by-destination-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    width: 100%;
    gap: ${toRem(16)};

    @media ${mediaQuery.mobileOnly} {
      grid-template-columns: 1fr;
    }

    @media ${mediaQuery.tabletOnly} {
      grid-template-columns: 1fr;
    }

    .near-by-destination-card {
      width: 100%;
      height: ${toRem(100)};
      border-radius: ${toRem(8)};
    }
  }
`;
